import { create } from "zustand";

export interface FocusedItem {
  id: string;
  name: string;
  description?: string;
  // World-space point the camera frames (bounding-sphere center).
  center: [number, number, number];
  // Ortho camera zoom that fits the model on screen.
  zoom: number;
  // Bounding-sphere radius of the focused model, world units. Used to size
  // the occlusion corridor that hides models standing in front of it.
  radius?: number;
  // Extra rotation of the focus direction around the vertical axis, in
  // radians (negative = clockwise seen from above). Used by arch/varch.
  yaw?: number;
  // Card button: label + what it does (open site, open modal, ...).
  actionLabel?: string;
  onAction?: () => void;
}

interface ProjectFocusStore {
  focused: FocusedItem | null;
  // Camera has arrived at the focus framing; gates the card's fade-in.
  settled: boolean;
  // True while the camera flies back to the free-roam view after an exit;
  // keeps OrbitControls disabled until the flight completes.
  restoring: boolean;
  // User zoom while focused (wheel / pinch), multiplies the auto-fit
  // framing. Reset to 1 on every focus change.
  viewZoom: number;
  setFocus: (item: FocusedItem) => void;
  clearFocus: () => void;
  setSettled: (value: boolean) => void;
  setRestoring: (value: boolean) => void;
  setViewZoom: (value: number) => void;
}

export const useProjectFocus = create<ProjectFocusStore>((set) => ({
  focused: null,
  settled: false,
  restoring: false,
  viewZoom: 1,
  setFocus: (item) =>
    set({ focused: item, settled: false, restoring: false, viewZoom: 1 }),
  clearFocus: () =>
    set({ focused: null, settled: false, restoring: true, viewZoom: 1 }),
  setSettled: (value) => set({ settled: value }),
  setRestoring: (value) => set({ restoring: value }),
  setViewZoom: (value) => set({ viewZoom: value }),
}));
